module.exports = __webpack_public_path__ + "static/media/art4.6a0790b8.jpg";